import React from 'react';
import { motion } from 'framer-motion';
import styles from './Contact.module.css';

const SocialLinks = () => {
  const socialLinks = [
    {
      name: 'GitHub',
      icon: '🐙',
      url: 'https://github.com/soorena80'
    },
    {
      name: 'LinkedIn',
      icon: '💼',
      url: 'https://www.linkedin.com/in/sourena-saneei-20a4b8291'
    },
    {
      name: 'Download Resume',
      icon: '📄',
      url: '/resume.pdf',
      download: true
    }
  ];

  return (
    <div className={styles.socialLinks}>
      <h3>Connect With Me</h3>
      <div className={styles.socialGrid}>
        {socialLinks.map((link, index) => (
          <motion.a
            key={link.name}
            href={link.url}
            target={link.download ? '_self' : '_blank'}
            rel="noopener noreferrer"
            className={styles.socialLink}
            download={link.download}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <span className={styles.socialIcon}>{link.icon}</span>
            <span className={styles.socialName}>{link.name}</span>
          </motion.a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks; 